module.exports = __webpack_public_path__ + "img/統計学入門_5_5_問題.3fe17a7e.png";